(function () {
  /* PEPY: "Size Chart in description ? collapsible panel".
     The Craft-ized main-product render strips <table> from the description,
     so if a Size Chart heading exists in the description but no table follows,
     we restore the table from /products/{handle}.js data, insert it after the
     note paragraph, then wrap it in a clippable box + a "Show More" pill
     button that matches the pe-quick-view button style. */
  var CSS_ID = 'pe-sc-collapse-css';
  if (!document.getElementById(CSS_ID)) {
    var style = document.createElement('style');
    style.id = CSS_ID;
    style.textContent =
      '.pe-sc-clip{position:relative;max-height:300px;overflow:hidden;transition:max-height .25s ease;}' +
      '.pe-sc-clip::after{content:"";position:absolute;left:0;right:0;bottom:0;height:56px;pointer-events:none;background:linear-gradient(rgba(var(--color-background),0),rgb(var(--color-background)));}' +
      '.pe-sc-collapse.open .pe-sc-clip{max-height:none;}' +
      '.pe-sc-collapse.open .pe-sc-clip::after{display:none;}' +
      '.pe-sc-toggle{display:flex;align-items:center;gap:6px;margin:10px auto 0;padding:8px 18px;background:#fffffff2;border:1px solid #e0d6cc;border-radius:30px;font-size:12px;font-weight:600;letter-spacing:.04em;color:#5a4d44;cursor:pointer;transition:border-color .2s;}' +
      '.pe-sc-toggle:hover{border-color:#5a4d44;}' +
      '.pe-sc-toggle .pe-sc-arrow{transition:transform .2s;font-size:10px;}' +
      '.pe-sc-collapse.open .pe-sc-arrow{transform:rotate(180deg);}';
    document.head.appendChild(style);
  }

  function toggleText(btn, open) {
    var label = btn.querySelector('.pe-sc-label');
    if (label) label.textContent = open ? 'Show Less' : 'Show More';
  }

  function wrap(table) {
    if (table.closest('.pe-sc-collapse')) return;
    var rows = table.rows ? table.rows.length : 0;
    var measured = table.offsetHeight;
    if (rows <= 5 && measured < 240) return; /* short tables stay open */

    var box = document.createElement('div');
    box.className = 'pe-sc-collapse';
    var clip = document.createElement('div');
    clip.className = 'pe-sc-clip';
    /* mount box first, then move the table inside - avoids self-insert */
    table.parentNode.insertBefore(box, table);
    box.appendChild(clip);
    clip.appendChild(table);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pe-sc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="pe-sc-label">Show More</span><span class="pe-sc-arrow" aria-hidden="true">&#9662;</span>';
    box.appendChild(btn);
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggleText(btn, open);
    });
  }

  function findSizeChartHeading() {
    var desc = document.querySelector('.product__description');
    if (!desc) return null;
    var headings = desc.querySelectorAll('h1,h2,h3,h4,h5,h6');
    for (var i = 0; i < headings.length; i++) {
      if (/size\s*chart/i.test(headings[i].textContent)) return headings[i];
    }
    return null;
  }

  function tableBelow(heading) {
    var desc = heading.closest('.product__description');
    if (!desc) return null;
    var tables = desc.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      /* returns the position of tables[i] relative to heading */
      if (heading.compareDocumentPosition(tables[i]) & Node.DOCUMENT_POSITION_FOLLOWING) return tables[i];
    }
    return null;
  }

  function restoreAndCollapse() {
    var heading = findSizeChartHeading();
    if (!heading) return;
    var desc = heading.closest('.product__description');
    if (tableBelow(heading)) { wrap(tableBelow(heading)); return; }
    /* table stripped at render - restore it from product data */
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m) return;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        /* another scan already restored it while this fetch was in flight */
        var existing = tableBelow(heading);
        if (existing) { wrap(existing); return; }
        if (!p.description || !/size\s*chart/i.test(p.description)) return;
        var hay = p.description.match(/<table[\s\S]*?<\/table>/i);
        if (!hay) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = hay[0];
        var tbl = tpl.content.querySelector('table');
        if (!tbl) return;
        /* insert right after the paragraph that follows the heading */
        var anchor = heading.nextElementSibling;
        if (anchor && anchor.tagName === 'P') { anchor.after(tbl); }
        else { heading.after(tbl); }
        wrap(tbl);
      })
      .catch(function () { /* page data not available, keep as-is */ });
  }

  function scan() {
    var seen = [];
    document.querySelectorAll('.pe-tab-panel table, .product__description table').forEach(function (t) {
      if (!t.closest('.pe-sc-collapse')) seen.push(t);
    });
    seen.forEach(wrap);
    restoreAndCollapse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
})();
